import React, { useState, useEffect } from "react";
import Preloader from "../../../components/Preloader/Preloader";
import { Redirect } from "react-router-dom"
import axios from "axios";
import {LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from '@material-ui/core/FormLabel';
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import MessageBox from "../../../components/MessageBox/MessageBox";
import ButtonComponent from 'react-button-component';
import LoadingOverlay from 'react-loading-overlay';
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
const useStyles = makeStyles((theme) => ({
	btnSearch: {
        marginTop: 30,
        backgroundColor: "green",
        marginRight:30
	},
    modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
    paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
}));
const ReceiveActivationCards = (props) => {
    const classes = useStyles();
    const [nextPagePath, setNextPagePath] = useState("");
    const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
    const [userName, setUsername] = useState(get_cookies('username'));
    const [idnoselected, setIdnoSelected] = useState("");
    const [receiveBtn, showReceiveBtn] = useState(false);
    const [isLoaded, setisLoaded] = useState();
    const [selectedIDNO, setSelectedIDNO] = useState([]);
    const min_releasedate = '2021-04-01';
    const TransactionInformation = {};
	const nextpage =  {
		// pathname: "/package-sales-payment",
		pathname: "/branch-package-purchase-firststep",
	}
    const nextpageEncoding =  {
        isCORelease:"yes"
	}
    const headers = {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': process.env.REACT_APP_API_URL,
    };
	//ApiData Component useState SOF
    const activationcardshqlist = () => {
        setisLoaded(false);
		//get data for warehouse/location dropdown
		const form_data = {
			hqidno: branchIdNo,
            prep_data: prep_data
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'activationcardshqlist';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            loadActivationCardList(res.data);
		});
	};

    const receiveactivationcards = (idnoarray) => {
        setShowOverlay(true);
        setOverlayMsg('Receiving Activation Cards...');
		//get data for warehouse/location dropdown
		const form_data = {
            username: userName,
			idnoarray: idnoarray
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'receiveactivationcards';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            if(res.data.result.success == 1){
				setShowMsgBox(true);
				setMsg(res.data.result.message);
				setMsgType("success");
				setTimeout(() => {
                    setShowOverlay(false);
                    setOverlayMsg('');
					setShowMsgBox(false);
				}, 3000)
                activationcardshqlist();
			}else{
				setShowMsgBox(true);
				setMsg(res.data.result.message);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
				}, 3000)
			}
		});
	};
	//ApiData Component useState EOF
	
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

    //Loading overlay
    const [showOverlay, setShowOverlay] = useState(false);
    const [overLayMsg, setOverlayMsg] = useState(false);
    //Loading overlay EOF

	//Table Settings
	const [TABLE_DATA, loadDataTable] = useState([]);

    const prep_selectedIDNO = () => {
        if(selectedIDNO.length > 0){
            let idnoselected = [];
            for(let i=0; i < selectedIDNO.length; i++){
                idnoselected.push(TABLE_DATA[selectedIDNO[i].index].idno);
            }
            receiveactivationcards(idnoselected);
        }else{
            setShowMsgBox(true);
            setMsg("Please select at least one idno to receive");
            setMsgType("warning");
            setTimeout(() => {
                setShowMsgBox(false);
            }, 3000)
        }
    }
    
	const loadActivationCardList = (data) => {
        refreshTable();
		const newData = [...TABLE_DATA];
        if(data.activationcardslist.length > 0){
            showReceiveBtn(true);
        }else{
            showReceiveBtn(false);
        }
		for (let i=0;i < data.activationcardslist.length;i++) {
            const tempObj = {
                    count:data.activationcardslist[i]['count'], 
                    trandate:data.activationcardslist[i]['date'], 
                    idno:data.activationcardslist[i]['idno']
                }
            newData.push(tempObj);
        }
		loadDataTable([...newData]);
        setisLoaded(true);
	};
    
	const refreshTable = () => {
        TABLE_DATA.length = 0;
        const newData = [...TABLE_DATA];
		loadDataTable([...newData]);
	}

	const TABLE_COLUMNS = [
        {
            name: 'count',
            label: 'Count',
        },
		{
		  name: 'trandate',
		  label: 'Date',
		}, {
		  name: 'idno',
		  label: 'ID No.',
		}
	];
	
	const TABLE_OPTION = {
        selectableRows: 'multiple',
        filterType: 'checkbox',
        onRowsSelect : (curRowSelected, allRowsSelected) => {
            setSelectedIDNO(allRowsSelected);
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
            ""
        )
	};
	//Table Settings EOF

	//Modal Settings
	const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
	const handleOpen = () => {
		setOpen(true);
	};
    const handleOpen2 = () => {
		setOpen2(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
    const handleClose2 = () => {
		setOpen2(false);
	};
	//Modal Settings EOF
    const formatDate = (date) => {
		let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

		if (month.length < 2) 
			month = '0' + month;
		if (day.length < 2) 
			day = '0' + day;

		return [year, month, day].join('-');
	}
    const proceedtoencoding = () => {
        props.history.push(nextpage);
    }
    //FormData
	const [prep_data, setData] = useState({"startDate":formatDate(new Date()),"endDate":formatDate(new Date())});
	//FormData EOF
	//OnLoad Event/Data Fetching SOF
	useEffect(() => {
        isLoggedIn();
        activationcardshqlist();
    }, []);
    //OnLoad Event/Data Fetching SOF

    // Date Picker
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const startDateChanged = (e) => {
        setStartDate(e);
        const newData = {...prep_data};
        newData['startDate']= formatDate(e);
        setData({ ...newData });
    }
    const endDateChanged = (e) => {
        setEndDate(e);
        const newData = {...prep_data};
        newData['endDate']= formatDate(e);
        setData({ ...newData });
    }
    //Date Picker EOF
	return (
		<div className="page">
            <LoadingOverlay
                active={showOverlay}
                spinner
                text={overLayMsg}
            >
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/sales">
						<h4 className="header-title">Sales</h4>
					</NavLink>
					<Typography color="textPrimary">Receive Activation Cards</Typography>
				</Breadcrumbs>
			</div>
            <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
			<div className="page-container">
                <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                            <KeyboardDatePicker
                                disableToolbar
                                variant="inline"
                                format="MM/dd/yyyy"
                                name="startDate"
                                label="From"
                                value={startDate}
                                inputVariant="outlined"
                                margin="normal"
                                required="true"
                                onChange={startDateChanged}
                                shouldCloseOnSelect={true}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <KeyboardDatePicker
                                disableToolbar
                                variant="inline"
                                format="MM/dd/yyyy"
                                name="endDate"
                                label="To"
                                value={endDate}
                                inputVariant="outlined"
                                margin="normal"
                                required="true"
                                shouldCloseOnSelect={true}
                                onChange={endDateChanged}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Button 
								variant="contained" 
								color="primary"
                                className={classes.btnSearch}
								onClick={(e) => {
									activationcardshqlist();
								}}>
								Search
							</Button>
                            {
                                receiveBtn ? 
                                <Button 
                                variant="contained" 
                                color="primary"
                                className={classes.btnSearch}
                                onClick={(e) => {prep_selectedIDNO();}}
                                >
                                Receive Activation Cards
                                </Button>
                                :
                                null      
                            }
                        </Grid>
                    </Grid>
                </MuiPickersUtilsProvider>
                <Grid item xs={12}>
                { 
                    !isLoaded ?  <Preloader /> :										
                    <MUIDataTable
                        title={
                            <div>
                                <div className="table-title">
                                    Receive Activation Cards
                                </div>
                            </div>
                        }
                        id="table-grid"
                        data={TABLE_DATA}
                        columns={TABLE_COLUMNS}
                        options={TABLE_OPTION}
                    />
                }
                </Grid>
			</div>
            </LoadingOverlay>
            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <div className={classes.paper}>
                            <h4 id="transition-modal-title">System Message</h4>
                            <form action="" className={classes.root}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        Are you sure you want to release this package?
                                    </Grid>
                                </Grid>
                                <div className={classes.button}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={2}>
                                        <Button
                                            variant="contained"
                                            onClick={handleClose}
                                            className={classes.buttonMarginRight}
                                        >
                                            No
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <Button 
                                            variant="contained" 
                                            color="primary" 
                                        >
                                            Yes
                                        </Button>
                                    </Grid>
                                    </Grid>
                                </div>
                            </form>
                        </div>
                    </Fade>
                </Modal>
            </div>
		</div>
	);
};

export default ReceiveActivationCards;
